// Inline icon set. Stroke-based, 1.6px, 24-unit grid — drawn here rather than
// pulled from an icon package so the bundle carries only what is used.

export type IconName =
  | 'file-text' | 'users' | 'box' | 'shield' | 'settings' | 'plus' | 'search'
  | 'download' | 'edit' | 'trash' | 'x' | 'check' | 'check-circle' | 'alert-circle'
  | 'chevron-left' | 'chevron-right' | 'chevron-down' | 'log-out' | 'menu'
  | 'globe' | 'image' | 'key' | 'arrow-left' | 'inbox' | 'save'
  | 'send' | 'mail' | 'file-plus' | 'clock' | 'arrow-right-circle';

const PATHS: Record<IconName, string> = {
  'file-text': 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M9 13h6M9 17h4',
  users: 'M16 20v-1.5a4 4 0 0 0-4-4H7a4 4 0 0 0-4 4V20M9.5 10.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M21 20v-1.5a4 4 0 0 0-3-3.87M16.5 3.6a4 4 0 0 1 0 7.75',
  box: 'M21 7.5 12 3 3 7.5m18 0v9L12 21m9-13.5L12 12m0 9L3 16.5v-9m9 13.5V12M3 7.5 12 12',
  shield: 'M12 21s7-3.5 7-9V6l-7-3-7 3v6c0 5.5 7 9 7 9M9.5 12l1.8 1.8 3.4-3.6',
  settings: 'M12 15.5a3.5 3.5 0 1 0 0-7 3.5 3.5 0 0 0 0 7M19.4 15a1.65 1.65 0 0 0 .33 1.82l.06.06a2 2 0 1 1-2.83 2.83l-.06-.06a1.65 1.65 0 0 0-1.82-.33 1.65 1.65 0 0 0-1 1.51V21a2 2 0 0 1-4 0v-.09A1.65 1.65 0 0 0 9 19.4a1.65 1.65 0 0 0-1.82.33l-.06.06a2 2 0 1 1-2.83-2.83l.06-.06A1.65 1.65 0 0 0 4.6 15a1.65 1.65 0 0 0-1.51-1H3a2 2 0 0 1 0-4h.09A1.65 1.65 0 0 0 4.6 9a1.65 1.65 0 0 0-.33-1.82l-.06-.06a2 2 0 1 1 2.83-2.83l.06.06A1.65 1.65 0 0 0 9 4.6h.09A1.65 1.65 0 0 0 10 3.09V3a2 2 0 0 1 4 0v.09a1.65 1.65 0 0 0 1 1.51 1.65 1.65 0 0 0 1.82-.33l.06-.06a2 2 0 1 1 2.83 2.83l-.06.06A1.65 1.65 0 0 0 19.4 9v.09a1.65 1.65 0 0 0 1.51 1H21a2 2 0 0 1 0 4h-.09a1.65 1.65 0 0 0-1.51 1',
  plus: 'M12 5v14M5 12h14',
  search: 'M11 18a7 7 0 1 0 0-14 7 7 0 0 0 0 14M20.5 20.5 16 16',
  download: 'M12 3v12m0 0 4.5-4.5M12 15l-4.5-4.5M4 17v2a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-2',
  edit: 'M12 20h8M4 20l4.5-1 10-10a2.12 2.12 0 0 0-3-3l-10 10z',
  trash: 'M4 7h16M10 11v6M14 11v6M5 7l1 13a2 2 0 0 0 2 2h8a2 2 0 0 0 2-2l1-13M9 7V4h6v3',
  x: 'M6 6l12 12M18 6 6 18',
  check: 'M4 12.5 9 17.5 20 6.5',
  'check-circle': 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M8.5 12.5l2.5 2.5 4.5-5',
  'alert-circle': 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M12 7.5v5M12 16h.01',
  'chevron-left': 'M14.5 5.5 8 12l6.5 6.5',
  'chevron-right': 'M9.5 5.5 16 12l-6.5 6.5',
  'chevron-down': 'M5.5 9.5 12 16l6.5-6.5',
  'log-out': 'M15 17l5-5-5-5M20 12H9M11 4H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2h5',
  menu: 'M4 7h16M4 12h16M4 17h16',
  globe: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M3.5 9h17M3.5 15h17M12 3a15 15 0 0 1 0 18M12 3a15 15 0 0 0 0 18',
  image: 'M5 4h14a1 1 0 0 1 1 1v14a1 1 0 0 1-1 1H5a1 1 0 0 1-1-1V5a1 1 0 0 1 1-1M4 16l4.5-4.5 4 4L16 12l4 4M9 9.5a1 1 0 1 0 0-2 1 1 0 0 0 0 2',
  key: 'M14.5 10.5a4 4 0 1 1 1.6-3.2M21 3l-8 8M17.5 6.5l2 2M14 10l2 2',
  'arrow-left': 'M20 12H4m0 0 6-6m-6 6 6 6',
  inbox: 'M4 13h4l1.5 3h5L16 13h4M4 13V6a2 2 0 0 1 2-2h12a2 2 0 0 1 2 2v7m-16 0v5a2 2 0 0 0 2 2h12a2 2 0 0 0 2-2v-5',
  save: 'M19 21H5a2 2 0 0 1-2-2V5a2 2 0 0 1 2-2h11l5 5v11a2 2 0 0 1-2 2M8 21v-7h8v7M8 3v4h6',
  send: 'M21 3 10.5 13.5M21 3l-6.5 18-4-8-8-4z',
  mail: 'M4 5h16a1 1 0 0 1 1 1v12a1 1 0 0 1-1 1H4a1 1 0 0 1-1-1V6a1 1 0 0 1 1-1M3.5 6.5l8.5 6 8.5-6',
  'file-plus': 'M14 3H7a2 2 0 0 0-2 2v14a2 2 0 0 0 2 2h10a2 2 0 0 0 2-2V8zM14 3v5h5M12 12v5M9.5 14.5h5',
  clock: 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M12 7v5l3.5 2',
  'arrow-right-circle': 'M21 12a9 9 0 1 1-18 0 9 9 0 0 1 18 0M10 8.5l3.5 3.5L10 15.5',
};

export interface IconProps {
  name: IconName;
  size?: number;
  className?: string;
}

export function Icon({ name, size = 16, className }: IconProps) {
  return (
    <svg
      className={className}
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      stroke="currentColor"
      strokeWidth={1.6}
      strokeLinecap="round"
      strokeLinejoin="round"
      aria-hidden="true"
      focusable="false"
    >
      <path d={PATHS[name]} />
    </svg>
  );
}
